import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';
import 'bootstrap/dist/js/bootstrap.min.js';

import '../css/inline.css';
import '../css/sidebar.css';
import '../css/style.css';
import '../css/usercontrols.css';
import 'material-design-icons/iconfont/material-icons.css';


import {pageReady} from "./main.js";

   window.XPeerConnection =  window.RTCPeerConnection||window.webkitRTCPeerConnection || window.mozRTCPeerConnection || window.msRTCPeerConnection;
   window.XSessionDescription = window.RTCSessionDescription || window.RTCSessionDescription || window.mozRTCSessionDescription || window.msRTCSessionDescription;
   window.XIceCandidate = window.RTCIceCandidate || window.RTCIceCandidate || window.mozRTCIceCandidate || window.msRTCIceCandidate;

   navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
   $(pageReady);
   

